module.exports = __webpack_public_path__ + "assets/img/PEI.f3233276.svg";